import React from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { colors } from '../../styles/variables';

const buttonStyles = css`
  display: inline-block;
  background-color: ${props => props.secondary ? colors.white : colors.secondary};
  color: ${props => props.secondary ? colors.secondary : colors.white};
  padding: ${props => props.large ? '16px 32px' : '8px 16px'};
  border-radius: 4px;
  font-weight: 500;
  font-size: ${props => props.large ? '18px' : '16px'};
  text-decoration: none;
  text-align: center;
  transition: background-color 0.2s, color 0.2s;
  border: ${props => props.secondary ? `1px solid ${colors.secondary}` : 'none'};
  cursor: pointer;
  
  &:hover {
    background-color: ${props => props.secondary ? colors.secondary : '#00a759'};
    color: ${props => props.secondary ? colors.white : colors.white};
  }
`;

const StyledButton = styled.button`
  ${buttonStyles}
`;

const StyledLink = styled(Link)`
  ${buttonStyles}
`;

const StyledAnchor = styled.a`
  ${buttonStyles}
`;

const Button = ({ children, to, href, secondary, large, ...props }) => {
  if (to) {
    return (
      <StyledLink to={to} secondary={secondary} large={large} {...props}>
        {children}
      </StyledLink>
    );
  }
  
  if (href) {
    return (
      <StyledAnchor href={href} secondary={secondary} large={large} {...props}>
        {children}
      </StyledAnchor>
    );
  }
  
  return (
    <StyledButton secondary={secondary} large={large} {...props}>
      {children}
    </StyledButton>
  );
};

export default Button;